import React, { Dispatch, FC, FunctionComponent, SetStateAction } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import {
    Container,
    createStyles,
    InputLabel,
    Link,
    MenuItem,
    Paper,
    Theme,
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import { SearchField } from '../../components/SearchField/SearchField';
import { SubstancesTable } from '../../components/SubstancesTable/SubstancesTable';
import { SearchBy } from '../../config/endpoints';
import { useTranslation } from 'react-i18next';
import Select from '@material-ui/core/Select';
// import Button from '@material-ui/core/Button';
import { AvailableTabs } from '../../shared/models/AvailableTabs';
import { useQueryResult } from '../../shared/store/substancesStore';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        inputRoot: {
            fontSize: theme.typography.h4.fontSize,
        },
        inputLabelRoot: {
            fontSize: theme.typography.h4.fontSize,
        },
        formControl: {
            width: '100%',
        },
        tableContainer: {
            margin: theme.spacing(5, 0, 0),
        },
        noResultsPaper: {
            padding: theme.spacing(8, 0),
            textAlign: 'center',
        },
        noResultsBodyMargin: {
            margin: theme.spacing(1, 0),
        },
        selectMenu: {
            height: '1.1876em',
        },
    }),
);

interface NoResultsMessageProps {
    onClick: Dispatch<SetStateAction<AvailableTabs>>;
}

const NoResultsMessage: FC<NoResultsMessageProps> = ({ onClick }) => {
    const classes = useStyles();
    const [t] = useTranslation();

    return (
        <Paper
            classes={{
                root: classes.noResultsPaper,
            }}
        >
            <Typography
                variant="h4"
                classes={{
                    root: classes.noResultsBodyMargin,
                }}
            >
                {t('No results')}
            </Typography>
            <Typography
                variant="body1"
                classes={{
                    root: classes.noResultsBodyMargin,
                }}
            >
                {/* {t(
                    'You can report suggestion for changes or new substances by clicking link below',
                )} */}
            </Typography>
            {/* <Button
                color="primary"
                classes={{
                    root: classes.noResultsBodyMargin,
                }}
                onClick={() => onClick(AvailableTabs.Report)}
            >
                {t('Report')}
            </Button> */}
        </Paper>
    );
};

interface SearchProps {
    onClick: Dispatch<SetStateAction<AvailableTabs>>;
}

export const Search: FunctionComponent<SearchProps> = ({ onClick }) => {
    const classes = useStyles();
    const [t] = useTranslation();

    const {
        data,
        next,
        pageNumber,
        params,
        prev,
        setPageSize,
        mutate,
        loading,
        pageSize,
        initial,
        total,
    } = useQueryResult();

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Container maxWidth="md">
                    <Typography variant="body1" paragraph component="div">
                        <Alert severity="info">
                            Wyszukiwarka substancji - usługa pomocnicza
                            ułatwiająca przyporządkowanie substancji emitowanej
                            do powietrza do odpowiednich pozycji na listach
                            substancji w systemie Krajowej bazy o emisjach gazów
                            cieplarnianych i innych substancji oraz w systemie
                            opłat za korzystanie ze środowiska - więcej w
                            zakładce{' '}
                            <Link
                                component="button"
                                onClick={() => onClick(AvailableTabs.About)}
                            >
                                O WYSZUKIWARCE
                            </Link>
                        </Alert>
                    </Typography>
                </Container>
            </Grid>
            <Grid item xs={2}>
                <FormControl className={classes.formControl}>
                    <InputLabel id="searchBy">{t('Search by')}</InputLabel>
                    <Select
                        value={params.searchBy}
                        classes={{ selectMenu: classes.selectMenu }}
                        onChange={(ev) => {
                            mutate({
                                pageNumber: 1,
                                resetData: true,
                                params: {
                                    searchBy: ev.target.value as SearchBy,
                                    search: '',
                                },
                            });
                        }}
                    >
                        <MenuItem value="name">{t('_Name')}</MenuItem>
                        <MenuItem value="cas">{t('CAS number')}</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={10}>
                <SearchField
                    label={
                        params.searchBy === 'name'
                            ? t('Type name')
                            : t('Type CAS number')
                    }
                    loading={loading}
                    value={params.search || ''}
                    onChange={(val) => {
                        mutate({
                            pageNumber: 1,
                            params: {
                                ...params,
                                search: val,
                            },
                        });
                    }}
                />
            </Grid>
            <Grid
                item
                xs={12}
                classes={{
                    root: classes.tableContainer,
                }}
            >
                <SubstancesTable
                    data={data}
                    loading={loading}
                    onPageSizeChange={(size) => {
                        setPageSize(size);
                    }}
                    onSetPage={(page) => {
                        if (page + 1 > pageNumber) next();
                        else prev();
                    }}
                    pageSize={pageSize}
                    allRows={total || 0}
                    page={pageNumber - 1}
                    noResultsMessage={() =>
                        !initial && <NoResultsMessage onClick={onClick} />
                    }
                />
            </Grid>
        </Grid>
    );
};
